import { useDispatch, useSelector } from "react-redux";
import ContainerHeader from "./ContainerHeader";
import Messages from "./Mesaages";
import SendForm from "./SendForm";
import { closeModal } from "../../features/messageActionSlice";
import { RootState } from "../../store";

const MessageContainer = () => {
  const dispatch = useDispatch();
  const isOpenMessageActionModal = useSelector(
    (state: RootState) => state.messageActionModal.isOpen
  );

  return (
    <div className="w-full sm:h-screen md:h-full flex flex-col justify-between bg-slate-100 relative">
      {isOpenMessageActionModal && (
        <div
          onClick={() => dispatch(closeModal())}
          className="absolute left-0 top-0 w-full h-full z-10"
        ></div>
      )}
      <ContainerHeader />
      <Messages />
      <SendForm />
    </div>
  );
};

export default MessageContainer;
